// extracted by mini-css-extract-plugin
export default {"lessonCardModalContainer":"LessonCardModal_lessonCardModalContainer__CzswG","outer":"LessonCardModal_outer__St6Va","inner":"LessonCardModal_inner__70sqF"};